import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const Container = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const PageTitle = styled.div`
  width: 300px;
  height: 32px;
  margin-bottom: 40px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;

  @media (max-width: 768px) {
    height: 28px;
    margin-bottom: 30px;
    width: 250px;
  }
`;

const Section = styled.div`
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const SectionTitle = styled.div`
  width: 200px;
  height: 20px;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;

  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const InfoLabel = styled.div`
  width: 120px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
`;

const InfoValue = styled.div`
  width: 200px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 250px;
  }
`;

const SkeletonButton = styled.div`
  width: 120px;
  height: 36px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 6px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const PersonalInfoSkeleton = () => {
  return (
    <Container>
      <Wrapper>
        <PageTitle />

        {/* Personal Details Section */}
        <Section>
          <SectionTitle />
          <InfoRow>
            <InfoLabel />
            <InfoValue />
          </InfoRow>
          <InfoRow>
            <InfoLabel />
            <InfoValue />
          </InfoRow>
          <InfoRow>
            <InfoLabel />
            <InfoValue />
          </InfoRow>
          <InfoRow>
            <InfoLabel />
            <div style={{ display: "flex", gap: "12px" }}>
              <InfoValue style={{ width: "150px" }} />
              <SkeletonButton style={{ width: "100px" }} />
            </div>
          </InfoRow>
        </Section>
      </Wrapper>
    </Container>
  );
};

export default PersonalInfoSkeleton;
